import { Component, OnInit } from '@angular/core';
import { UserService } from '../../../shared/services/user.service';
import { CommonService } from '../../../shared/services/common.service';
import { environment } from '../../../../environments/environment';
import { Router, NavigationEnd, Event, NavigationStart, NavigationError, RoutesRecognized } from '@angular/router';

@Component({
  selector: 'app-register',
  templateUrl: './register.component.html',
  styleUrls: ['./register.component.scss']
})
export class RegisterComponent implements OnInit {

  public user_name = '';
  public mobile = '';
  public email = '';
  public password = '';
  public errorOccurred = false;
  public errorOccurredMessage = '';


  successEmail: boolean = false;
  public errorSuccessEmailMessage = '';
  successUser_name: boolean = false;
  public errorUserNameMessage = '';
  successMobile: boolean = false;
  errorMobileMessage = "";
  successPassword: boolean = false;
  errorPasswordMessage = "";
  page_name = localStorage.getItem('front-lang') == 'ar' ? "تسجيل حساب جديد" : "Register";

  constructor(private user: UserService, private coomenservice: CommonService, private router: Router) { }

  ngOnInit(): void {
  }

  userSignUp() {
    this.errorOccurred = false;
    this.errorOccurredMessage = "";
    this.successUser_name = false;
    this.successEmail = false;
    this.successPassword = false;
    this.successMobile = false;
    if (this.user_name == '') {
      this.successUser_name = true;
      this.errorOccurred = true;
      this.errorOccurredMessage = "Enter Full Name";
    }

    if (this.email == '' || this.coomenservice.validateEmail(this.email) == false) {
      this.successEmail = true;
      this.errorOccurred = true;
      this.errorOccurredMessage = "Enter Valid Email";
    }
    if (this.password == '') {
      this.successPassword = true;
      this.errorOccurred = true;
      this.errorOccurredMessage = "Enter Valid Password";
    }
    if (this.mobile == '') {
      this.successMobile = true;
      this.errorOccurred = true;
      this.errorOccurredMessage = "Enter Valid Mobile";
    }

    if (this.successUser_name === true || this.successMobile === true || this.successPassword === true || this.successEmail === true) {
      return;
    } else {

      let body = {
        "user_name": this.user_name,
        "mobile": this.mobile,
        "email": this.email,
        "password": this.password,
      }


      this.user.userSignUp(body).subscribe((data) => {
        if (data.data) {

          localStorage.setItem("clientToken", data.data.authentication_code);
          localStorage.setItem("affiliatorToken", environment.affiliator_token);
          localStorage.setItem("currentUserFront", JSON.stringify(data.data));

          // Call Merge API To Merge Cart List
          this.user.shareCartList().subscribe(data => {
            console.log(JSON.stringify(data));
          });

          this.user.userLoggedIn(data.data.user_name);
          if (localStorage.getItem('previousUrl') !== '' && localStorage.getItem('previousUrl') != null && localStorage.getItem('previousUrl') != '/pages/my-account') {
            this.router.navigate([localStorage.getItem('previousUrl')]);
          } else {
            this.router.navigate(['/pages/dashboard']);
          }
        } else {

          this.errorOccurred = false;
          this.errorOccurredMessage = '';
          this.successUser_name = false;
          this.errorUserNameMessage = '';
          this.successEmail = false;
          this.errorSuccessEmailMessage = '';
          this.successPassword = false;
          this.errorPasswordMessage = '';
          this.successMobile = false;
          this.errorMobileMessage = '';
          if (data.errors) {
            this.errorOccurred = true;
            this.errorOccurredMessage = data.message;
          }
          if (data.errors['user_name']) {
            this.successUser_name = true;
            this.errorUserNameMessage = data.errors['user_name'];
          }
          if (data.errors['email']) {
            this.successEmail = true;
            this.errorSuccessEmailMessage = data.errors['email'];
          }
          if (data.errors['password']) {
            this.successPassword = true;
            this.errorPasswordMessage = data.errors['password'];
          }
          if (data.errors['mobile']) {
            this.successMobile = true;
            this.errorMobileMessage = data.errors['mobile'];
          }

          return;
        }
      });
    }
  }


}
